import { Link } from 'react-router-dom';
import { rankingCards } from '../../../../mocks/ranking-cards';

export default function CardRanking() {
  // Filter instant issue cards
  const instantCards = rankingCards.filter(card => 
    card.id === 'mitsui' || card.id === 'rakuten' || card.id === 'suruga'
  );

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-[#003366] mb-12">
          即日発行カードおすすめランキング
        </h2>

        <div className="space-y-8">
          {instantCards.map((card, index) => (
            <div
              key={card.id}
              className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow overflow-hidden"
            >
              <div className="p-6 md:p-8">
                <div className="flex flex-col md:flex-row gap-6">
                  {/* Rank Badge */}
                  <div className="flex-shrink-0">
                    <div className={`w-20 h-20 flex items-center justify-center rounded-full font-bold text-2xl ${
                      index === 0 ? 'bg-[#FFD700] text-white' :
                      index === 1 ? 'bg-[#C0C0C0] text-white' :
                      'bg-[#CD7F32] text-white'
                    }`}>
                      {index + 1}位
                    </div>
                  </div>

                  {/* Card Info */}
                  <div className="flex-1">
                    <div className="flex flex-col md:flex-row md:items-start gap-6 mb-6">
                      {/* Logo */}
                      <div className="w-48 h-32 flex items-center justify-center bg-gray-50 rounded-lg p-4">
                        <img
                          src={card.logo}
                          alt={card.name}
                          className="w-full h-full object-contain"
                        />
                      </div>

                      {/* Details */}
                      <div className="flex-1">
                        <h3 className="text-2xl font-bold text-[#003366] mb-4">
                          <Link to={card.detailUrl} className="hover:text-[#FF9900] hover:underline transition-colors cursor-pointer">
                            {card.name}
                          </Link>
                        </h3>
                        
                        <div className="grid grid-cols-2 gap-4 mb-4">
                          <div>
                            <p className="text-sm text-gray-600 mb-1">還元率</p>
                            <p className="text-xl font-bold text-[#FF9900]">{card.returnRate}</p>
                          </div>
                          <div>
                            <p className="text-sm text-gray-600 mb-1">年会費</p>
                            <p className="text-xl font-bold text-[#003366]">{card.annualFee}</p>
                          </div>
                        </div>

                        {/* Benefits */}
                        <div className="space-y-2 mb-6">
                          <p className="text-sm font-bold text-gray-700 mb-2">おすすめポイント</p>
                          {card.benefits.map((benefit, idx) => (
                            <div key={idx} className="flex items-start gap-2">
                              <i className="ri-check-line text-[#FF9900] text-lg flex-shrink-0 w-6 h-6 flex items-center justify-center"></i>
                              <p className="text-gray-700 text-sm">{benefit}</p>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>

                    {/* CTA Buttons */}
                    <div className="flex flex-col sm:flex-row gap-3">
                      <a
                        href={card.officialUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex-1 bg-[#FF9900] hover:bg-[#E68A00] text-white font-bold px-6 py-3 rounded-lg transition-all text-center cursor-pointer whitespace-nowrap"
                      >
                        公式サイトを見る
                      </a>
                      <Link
                        to={card.detailUrl}
                        className="flex-1 bg-white hover:bg-gray-50 text-[#003366] font-bold px-6 py-3 rounded-lg border-2 border-[#003366] transition-all text-center cursor-pointer whitespace-nowrap"
                      >
                        詳細を見る
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* おすすめカードへのリンク */}
        <div className="mt-12 bg-gradient-to-r from-[#2C5F5D] to-[#3D7A78] rounded-2xl p-8 text-white">
          <div className="text-center mb-6">
            <h3 className="text-2xl font-bold mb-2">即日発行カードをもっと詳しく</h3>
            <p className="text-white/80">各カードの詳細ページで申込方法や特典をチェック</p>
          </div>
          <div className="flex flex-wrap justify-center gap-4">
            <Link
              to="/mitsui"
              className="inline-flex items-center gap-2 bg-white text-[#2C5F5D] font-bold px-6 py-3 rounded-xl hover:bg-gray-100 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-timer-flash-line"></i>
              三井住友カード詳細
            </Link>
            <Link
              to="/suruga"
              className="inline-flex items-center gap-2 bg-white text-[#2C5F5D] font-bold px-6 py-3 rounded-xl hover:bg-gray-100 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-speed-line"></i>
              地方銀行系スピード発行カード詳細
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
